import { useEffect, useState } from "react";
import { Menu, X, Leaf } from "lucide-react";

const links = [
  { href: "#story", label: "Story", id: "nav-story" },
  { href: "#philosophy", label: "Philosophy", id: "nav-philosophy" },
  { href: "#products", label: "Remedies", id: "nav-products" },
  { href: "#voices", label: "Voices", id: "nav-voices" },
  { href: "#contact", label: "Consult", id: "nav-contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-[#F8F5F0]/80 border-b border-[#DCD3C6]"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 flex items-center justify-between h-16 md:h-20">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-2 group"
        >
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-[#2E3A2F] text-[#F8F5F0] transition-transform group-hover:rotate-12">
            <Leaf className="h-4 w-4" strokeWidth={1.5} />
          </span>
          <span className="font-serif-display text-2xl leading-none tracking-tight">
            Ayurvedauniversal
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.id}
              href={l.href}
              data-testid={l.id}
              className="text-sm text-[#2E3A2F]/80 hover:text-[#C05C46] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          data-testid="nav-cta-consult"
          className="hidden md:inline-flex btn-primary text-xs"
        >
          Book Consultation
        </a>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden inline-flex items-center justify-center h-10 w-10 rounded-full border border-[#DCD3C6]"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden bg-[#F8F5F0] border-t border-[#DCD3C6] px-6 py-6 space-y-4"
        >
          {links.map((l) => (
            <a
              key={l.id}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block text-lg font-serif-display"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            className="btn-primary w-full justify-center"
          >
            Book Consultation
          </a>
        </div>
      )}
    </header>
  );
}
